import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { api } from './api'
import * as actions from './actions'
import * as selectors from './selectors'

function fetchEvents(action$) {
  return action$
    .ofType(actions.fetchTimelineEventsForEndUser.toString())
    .pluck('payload')
    .switchMap(({ endUserId, size, filter }) => {
      return api
        .fetch(endUserId, { filter, size })
        .takeUntil(action$
          .ofType(actions.fetchTimelineEventsForEndUserCancelled.toString())
          .filter(action => action.payload.endUserId === endUserId)
        )
        .map(actions.fetchTimelineEventsForEndUserSuccess)
        .startWith(actions.fetchTimelineEventsForEndUserPending({ endUserId }))
        .catch(error => {
          return Observable.of(actions.fetchTimelineEventsForEndUserFailed({ endUserId, error }))
        })
    })
}

function loadMoreEvents(action$, { getState }) {
  return action$
    .ofType(actions.loadMoreTimelineEventsForEndUser.toString())
    .filter(() => selectors.hasNext(getState()))
    .pluck('payload')
    .switchMap(({ endUserId, size, filter }) => {
      const cursor = selectors.cursor(getState())
      return api
        .fetch(endUserId, { filter, size, after: cursor })
        .takeUntil(action$.ofType(
          actions.fetchTimelineEventsForEndUser.toString(),
          actions.loadMoreTimelineEventsForEndUserCancelled.toString(),
        ))
        .map(actions.loadMoreTimelineEventsForEndUserSuccess)
        .startWith(actions.loadMoreTimelineEventsForEndUserPending({ endUserId }))
        .catch(error => {
          return Observable.of(actions.loadMoreTimelineEventsForEndUserFailed({ endUserId, error }))
        })
    })
}

export const epic = combineEpics(fetchEvents, loadMoreEvents)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/timeline/epic.js